import React from "react";
import { AuthorBylineSection } from "../../../components/AuthorByline/authorBylineSection";
import { AuthorByline, IAuthorByLineProps } from "../../../components/AuthorByline";
import { AuthorBylineDate } from "../../../components/AuthorByline/authorBylineDate";

export type GetAuthorByLineProps =
  IAuthorByLineProps & { updatedAt: string }

export const getAuthorByLine = ({
  heading,
  name,
  title,
  image,
  url,
  updatedAt,
}: GetAuthorByLineProps) => (
  <AuthorBylineSection>
    <AuthorByline
      heading={heading}
      name={name}
      title={title}
      image={image}
      url={url}
    />
    <AuthorBylineDate date={updatedAt} />
  </AuthorBylineSection>
);
